export const GetCurrencySymbol = (currencyName: string) => {
  switch (currencyName.toLowerCase()) {
    case 'dollar':
      return '$';
    case 'afn':
      return '؋'; // AFN symbol (Afghan Afghani)
    default:
      return ''; // Default case, you can return an empty string or a fallback symbol
  }
};